import { render, staticRenderFns } from "./previewImgList.vue?vue&type=template&id=bb4eb13c&scoped=true&"
import script from "./previewImgList.vue?vue&type=script&lang=js&"
export * from "./previewImgList.vue?vue&type=script&lang=js&"
import style0 from "./previewImgList.vue?vue&type=style&index=0&id=bb4eb13c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4eb13c",
  null
  
)

export default component.exports